import { render, staticRenderFns } from "./StepSubmit.vue?vue&type=template&id=63a40504&scoped=true&"
import script from "./StepSubmit.vue?vue&type=script&lang=js&"
export * from "./StepSubmit.vue?vue&type=script&lang=js&"
import style0 from "./StepSubmit.vue?vue&type=style&index=0&id=63a40504&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63a40504",
  null
  
)

export default component.exports